import BarChart from "components/charts/BarChart";
import LineChart from "components/charts/LineChart";
import PieChart from "components/charts/PieChart";
import Modals from "components/Modal";
import TableTwo from "components/TableTwo";
import { format } from "date-fns";
import useDefaultReport from "hook/reports/useDefaultReport";
import { DEFAULT_DONATION } from "navigation/routes";
import { Link } from "react-router-dom";
const DefaultAnalytics = () => {
  const { dummy_data, dummy_line_data, dummy_pie_data } = useDefaultReport()
  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>Default Analytics</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item"><Link to={`../${DEFAULT_DONATION}`}>Defaults</Link></li>
              <li className="breadcrumb-item active">Analytics</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${DEFAULT_DONATION}`} relative="path">View List</Link>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header">
                  <i className="fas fa-chart-bar me-1"></i>
                  {format(new Date(), 'yyyy')} Defaulters by month
                </div>
                <div className="card-body">
                  <BarChart data={dummy_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header">
                  <i className="fas fa-chart-bar me-1"></i>
                  All Defaulters
                </div>
                <div className="card-body">
                  <LineChart data={dummy_line_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card mb-4">
                <div className="card-header">
                  <i className="fas fa-chart-bar me-1"></i>
                  Total Defaulters categorized by Level for {format(new Date(), 'yyyy')}
                </div>
                <div className="card-body">
                  <PieChart data={dummy_pie_data} />
                </div>
                <div className="card-footer small text-muted">Updated yesterday at 11:59 PM
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DefaultAnalytics
